import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch (e) { /* retry */ }
      tries.current += 1;
      if (tries.current < 15) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        {status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-primary mx-auto animate-spin" />
            <h1 className="font-display text-3xl mt-6">Confirming your payment</h1>
            <p className="text-muted-foreground mt-3 text-sm">This takes a few seconds...</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 data-testid="payment-confirmed-icon" className="w-12 h-12 text-emerald-400 mx-auto" />
            <h1 className="font-display text-3xl mt-6">You're subscribed</h1>
            <p className="text-muted-foreground mt-3 text-sm">Your new plan is active on your restaurant dashboard.</p>
            <Link to="/dashboard">
              <Button data-testid="goto-dashboard-btn" className="mt-8 rounded-full">Go to dashboard</Button>
            </Link>
          </>
        )}
        {(status === "pending" || status === "failed") && (
          <>
            <XCircle className="w-12 h-12 text-amber-300 mx-auto" />
            <h1 className="font-display text-3xl mt-6">Payment still processing</h1>
            <p className="text-muted-foreground mt-3 text-sm">Check your billing page in a moment — it will update automatically.</p>
            <Link to="/dashboard">
              <Button data-testid="goto-dashboard-btn-2" variant="outline" className="mt-8 rounded-full">Back to dashboard</Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
